import React from 'react';
import moment from 'moment';
import axios from 'axios';
import { DataGrid } from '@mui/x-data-grid';
import Stack from '@mui/material/Stack';
import { domain } from '../../Variables/domain';

function BillingIn() {
  const [tableData, setTableData] = React.useState([]);
  // console.log(tableData)

  const columns = [
    // { field: 'id', headerName: 'ID', width: 0, hidden: 'true'},
    {
      field: 'car_number',
      headerName: 'ປ້າຍລົດ',
      headerClassName: 'bg-[#26B899] text-white',
      width: 160,
    },
    {
      field: 'card',
      headerName: 'ຊື່ບັດ',
      headerClassName: 'bg-[#26B899] text-white',
      width: 150,
      valueGetter: function (params) {
        if (params.row.card?.card_id === undefined) {
          return 'ບໍ່ມີຂໍ້ມູນ';
        } else {
          return params.row.card.card_id;
        }
      },
    },
    {
      field: 'phone_number',
      headerName: 'ເບີໂທຕິດຕໍ່',
      headerClassName: 'bg-[#26B899] text-white',
      width: 200,
    },
    {
      field: 'rent_start',
      headerName: 'ເວລາເຂົ້າ',
      headerClassName: 'bg-[#26B899] text-white',
      width: 200,
      valueGetter: (params) =>
        moment(params.row.rent_start).format('DD/MM/YYYY HH:mm:ss'),
    },
  ];

  const getSensor = async () => {
    try {
      const resp = await axios.get(`${domain}/bill/getRentIn`);
      setTableData(resp.data);
    } catch (error) {
      console.log(error);
    }
  };

  React.useEffect(() => {
    getSensor();

    const interval = setInterval(() => {
      getSensor();
    }, 300000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="w-full flex flex-col">
      <h4 className="text-xl mb-2 font-semibold">ຮັບລົດເຂົ້າ</h4>
      <div className="w-full h-96 shadow-sm">
        <DataGrid
          columns={columns}
          rows={tableData}
          loading={tableData.length > 0 ? false : true}
          components={{
            NoRowsOverlay: () => (
              <Stack height="100%" alignItems="center" justifyContent="center">
                ບໍ່ມິຂໍ້ມູນ
              </Stack>
            ),
          }}
          sx={{ border: 'none', fontSize: '16px' }}
          pageSize={5}
          rowsPerPageOptions={[5]}
          pagination
        />
      </div>
    </div>
  );
}

export default BillingIn;
